import { useUsers } from "@crm/api";
import { Users, User } from "lucide-react";
import { cn } from "@crm/utils";

const roleConfig: Record<string, { label: string; color: string }> = {
  admin: { label: "Admin", color: "bg-purple-100 text-purple-800" },
  manager: { label: "Manager", color: "bg-blue-100 text-blue-800" },
  technician: { label: "Technician", color: "bg-green-100 text-green-800" },
};

export function WorkersListPage() {
  const { data, isLoading, error } = useUsers();

  // Filter to show only staff members (not clients)
  const workers = data?.results?.filter((user) => user.role !== "client") || [];

  return (
    <div className="p-8">
      {/* Header */}
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-foreground">Workers</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Team members who can be assigned to incidents
        </p>
      </div>

      {/* Content */}
      {isLoading ? (
        <div className="flex h-64 items-center justify-center">
          <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        </div>
      ) : error ? (
        <div className="rounded-lg border border-destructive bg-destructive/10 p-8 text-center">
          <p className="text-destructive">Failed to load workers</p>
        </div>
      ) : !workers.length ? (
        <div className="rounded-lg border border-border bg-card p-8 text-center">
          <Users className="mx-auto h-12 w-12 text-muted-foreground" />
          <p className="mt-4 text-muted-foreground">No workers found.</p>
        </div>
      ) : (
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {workers.map((worker) => {
            const role = roleConfig[worker.role] || roleConfig.technician;
            return (
              <div
                key={worker.id}
                className="rounded-lg border border-border bg-card p-6"
              >
                <div className="flex items-start gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-full bg-muted">
                    <User className="h-6 w-6 text-muted-foreground" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-foreground">
                      {worker.first_name} {worker.last_name}
                    </h3>
                    <p className="text-sm text-muted-foreground">
                      {worker.email}
                    </p>
                    <span
                      className={cn(
                        "mt-2 inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium",
                        role.color
                      )}
                    >
                      {role.label}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
